export const filterComparisonData = (comparisonData, ordinaryTariffAlias, secondaryTariffAlias) => {
  const selectedTariffs = [ordinaryTariffAlias, secondaryTariffAlias];
  const filteredData = comparisonData.map((sectionData) => ({
    section: sectionData.section,
    values: sectionData.values
      .map((item) => ({ ...item, for_tariffs: item.for_tariffs.split(', ') }))
      .filter((item) => item.for_tariffs.some((tariff) => selectedTariffs.includes(tariff))),
  }));
  return {
    diffData: filteredData
      .map((sectionData) => ({
        section: sectionData.section,
        values: sectionData.values.filter(
          (item) =>
            item.caption.includes('[MONTH]') ||
            item.caption.includes('[YEAR]') ||
            (item.for_tariffs.includes(ordinaryTariffAlias) && !item.for_tariffs.includes(secondaryTariffAlias)) ||
            (!item.for_tariffs.includes(ordinaryTariffAlias) && item.for_tariffs.includes(secondaryTariffAlias))
        ),
      }))
      .filter((sectionData) => sectionData.values.length > 0),
    allData: filteredData,
  };
};
